'use client';
import * as e from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const StepIndicatorContext = e.createContext(void 0);
StepIndicatorContext.displayName = 'StepIndicatorContext';
const useStepIndicatorContext = ()=>useNonNullishContext(StepIndicatorContext);

export { StepIndicatorContext, useStepIndicatorContext };
